import zhHans from 'vuetify/es5/locale/zh-Hans'

// Usage -> {{$vuetify.lang.t('$vuetify.close')}} -> 關閉
export default {
  ...zhHans
}
